// TODO ESTANDARIZAR

import React from 'react';
import { getDateTimeString, getLocalDateTimeString, getLocalDateString,getTime, getHora } from './FechasService';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import { InputNumber } from 'primereact/inputnumber';
// import { fontSize, fontWeight } from '@mui/system';
// import { Button } from 'primereact/button';

// TEMPLATE TEXT
export const textTemplate = (text, onDoubleClick = null) => {
    return (
        <div className='tooltipContent'>
            {/* <Tooltip className='toltipClass' target=".text-overFlow" mouseTrack mouseTrackLeft={10} tooltipOptions={{position: 'right'}} /> */}
            {/* <InputText types="text" placeholder="Right" tooltip={text} tooltipOptions={{position: 'right'}}/> */}
            <span className='text-overFlow' onDoubleClick={onDoubleClick} data-toggle="tooltip" data-placement="top" title={text} >{ text }</span>
            {/* <span className="tooltiptext">{text}</span> */}
        </div>
    )
}

// TEMPLATE TEXT CENTER
export const textCenterTemplate = (text, onDoubleClick = null) => {
    return <span className='text-overFlow text-alingth-center d-flex' style={{ height: '100%', alignItems: 'center', justifyContent: 'center'}} onDoubleClick={onDoubleClick}>{text}</span>;
}

// FECHA TEMPLATE
export const fechaTemplate = (date) => {
    if (date != null) {
        return <span >{getDateTimeString(new Date(date)).toLocaleString('en-US', { timeZone: "Antarctica/Vostok" })}</span>
    } else {
        return '';
    }
}

export const fechaRealTemplate = (date) => {
    if (date != null) {
        return <span >{getLocalDateTimeString(new Date(date))}</span>
    } else {
        return '';
    }
}

// FECHA TEMPLATE
export const fechaLocalStringTemplate = (date) => {
    if (date != null) {
        return <span >{getLocalDateString(new Date(date))}</span>
    } else {
        return '';
    }
}

// FECHA TEMPLATE
export const fechaLocalTemplate = (date) => {
    if (date != null) {
        return <span >{getLocalDateTimeString(new Date(date))}</span>
    } else {
        return '';
    }
}

// HORA TEMPLATE
export const horaTemplate = (date) => {
    if (date != null) {
        return <span >{getTime(new Date(date))}</span>
    } else {
        return '';
    }
}

// HORA Local TEMPLATE
export const horaLocalTemplate = (date) => {
    if (date != null) {
        return <span >{getHora(new Date(date))}</span>
    } else {
        return '';
    }
}


// DECIMAL
export const decimalTemplate = (decimal, currencySimbol, fixed) => {
    if (decimal !== null && typeof decimal === 'number') {
        return <span className='text-alingth-right  w-100'>{ (currencySimbol? currencySimbol: '') + (decimal != null ? formatNumber(decimal) : '0.00000')}</span>;
    }
    else {
        return <span className='text-alingth-right w-100'>{'0.00000'}</span>;
    }
}

export const formatNumber = (num) => {
        // Redondeamos el número a un máximo de 5 decimales
        num = Number(num?.toFixed(5));
        
        // Convertimos el número a una cadena y separamos la parte entera y decimal
        let parts = num.toString().split('.');
        
        // Si el número no tiene parte decimal, añadimos '.00'
        if (parts.length === 1) {
          parts.push('00');
        }
        
        // Si la parte decimal tiene menos de 2 dígitos, añadimos ceros a la derecha
        if (parts[1].length < 2) {
          parts[1] = parts[1] + '0'.repeat(2 - parts[1].length);
        }
        
        // Separamos la parte entera en grupos de 3 dígitos
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        
        // Unimos la parte entera y decimal con un punto como separador decimal
        return parts.join('.');
}

// DECIMAL
export const decimalValueTemplate = (decimal) => {
    if (decimal !== null && typeof decimal === 'number') {
        return decimal !== 0 ? decimal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00';
    }
    else {
        return '0.00';
    }
}
// DECIMAL
export const decimalValueClearTemplate = (decimal) => {
    if (decimal !== null && typeof decimal === 'number') {
        return decimal !== 0 ? decimal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ' ';
    }
    else {
        return ' ';
    }
}


// ESTADO PURCHASE REQUEST
export const estadoTemplate = (IdEstado, EstadoPD, Background, Color) => {
    const tieneColorApi = Background || Color;

    return (
        <span
            className={tieneColorApi ? "" : `status-${IdEstado}`}
            style={{
                backgroundColor: Background,
                color: Color,
                textAlign: 'center',
                width: '100%',
                display: 'block',
                fontWeight: 700,
                fontSize: '12px',
                letterSpacing: '.3px',
            }}
        >
            {EstadoPD}
        </span>
    );
}


// CHECKBOX TEMPLATE
export const checkBoxTemplate = ({value = null, disabled = true, onChange = () => {}, rowData = undefined, setDisable = undefined, tooltip=''}) => {
    if(setDisable) {
        disabled = setDisable(rowData);
    }
    return (
        <div onDoubleClick={e => !disabled  ? ()=>{} :   onChange(e, rowData)} className='w-100 divFullCenter' style={{ justifyContent: 'center' }}>
            <Checkbox className='alingth-center' checked={value == 1} disabled={!disabled} tooltip={tooltip}></Checkbox>
        </div>)
}
// Dropdown TEMPLATE
export const dropdownTemplate = (dropOptions, options, onChange, params = {}, placeholder = '') => {
    return <Dropdown value={dropOptions.value} options={options} onChange={e => onChange(e, params)} itemTemplate={ItemTemplate} placeholder={placeholder} className="p-column-filter" showClear />;
}

// ********************************************
//              EDITOR TEMPLATES
// ********************************************
// INPUT NUMBER
export const inputNumberTemplate = (value, onChange, params, placeholder = '') => {
    // console.log(value)
    return <InputNumber mode="decimal" locale="en-US" minFractionDigits={2} maxFractionDigits={2}  value={value} onChange={e => onChange(e, params)} placeholder={placeholder} className="p-column-filter" showClear />;
}

// ITEM FILTER TEMPLATE PARA LOS DROPDOWN
const ItemTemplate = (option) => {
    return <span value={option}>{option}</span>;
}

// ********************************************
//              FILTERS TEMPLATES
// ********************************************
// DROPDOWN
export const dropdownFilterTemplate = (dropOptions, options, placeholder = '') => {
    return <Dropdown value={dropOptions.value} options={options} onChange={e => dropOptions.filterApplyCallback(e.value)} itemTemplate={ItemTemplate} placeholder={placeholder} className="p-column-filter" showClear />;
}
// INPUT NUMBER
export const inputNumberFilterTemplate = (dropOptions, placeholder = '') => {
    return <InputText keyfilter='pnum' value={dropOptions.value} onChange={e => dropOptions.filterApplyCallback(e.target.value)} placeholder={placeholder} className="p-column-filter" showClear />;
}

// CON PRECIO
export const checkFilterTemplate = (data, values, opt) => {
    return <Dropdown value={data.value === undefined || data.value === null ? undefined : data.value === true ? opt[0] : opt[1]} options={values} onChange={(e) => data.filterApplyCallback(e.value)} itemTemplate={options => currencyItemTemplate(options, opt)} className="p-column-filter" showClear />;
}

const currencyItemTemplate = (option, opt) => {
    return <span >{option ? opt[0] : opt[1]}</span>;
}
// DATE FILTER 
export const dateFilterTemplate = (options) => {
    return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="dd/mm/yy" placeholder="dd/mm/yy" mask="99/99/9999" />
}

export const multiSelectTemplate = (dropOptions, options) =>{
  return  <MultiSelect value={dropOptions.value} options={options} onChange={(e) => dropOptions.filterApplyCallback(e.value)} filterBy='StatusName' className="p-column-filter" maxSelectedLabels={1} showClear />
}

export const categoriaTemplate = (Id, Categoria) => {
    return <span className={`purchase-badge category-${Id}`}>{Categoria}</span>;
}